import { api } from '../lib/api';
import type { AppUser, Role } from '../types/api';

export async function listUsersForOrg(orgId: string): Promise<AppUser[]> {
  const { data } = await api.get<AppUser[]>('/users', { params: { orgId } });
  return data;
}

// Oakford staff directory - MSP Admin only (enforced server-side too).
export async function listMspAdmins(): Promise<AppUser[]> {
  const { data } = await api.get<AppUser[]>('/users/msp-admins');
  return data;
}

export interface SiteRoleAssignmentInput {
  siteId: string;
  role: Extract<Role, 'SIGNING_AUTHORITY' | 'END_USER'>;
}

export interface CreateUserInput {
  email: string;
  firstName?: string;
  lastName?: string;
  password: string;
  customerAdminForOrgId?: string;
  reportsViewerForOrgId?: string;
  siteRoles?: SiteRoleAssignmentInput[];
  // Creates an Oakford staff (MSP Admin) account instead of a customer-side
  // one - mutually exclusive with every field above. Only honoured server-
  // side when the requester is themselves an MSP Admin.
  isMspAdmin?: boolean;
}

export async function createUser(input: CreateUserInput): Promise<AppUser> {
  const { data } = await api.post<AppUser>('/users', input);
  return data;
}

export async function updateUserStatus(userId: string, status: 'ACTIVE' | 'INACTIVE'): Promise<AppUser> {
  const { data } = await api.patch<AppUser>(`/users/${userId}/status`, { status });
  return data;
}

export interface UpdateUserRolesInput {
  orgId: string;
  isCustomerAdmin?: boolean;
  isReportsViewer?: boolean;
  siteRoles?: SiteRoleAssignmentInput[];
}

export async function updateUserRoles(userId: string, input: UpdateUserRolesInput): Promise<AppUser> {
  const { data } = await api.patch<AppUser>(`/users/${userId}/roles`, input);
  return data;
}

export async function resetUserPassword(userId: string, password: string): Promise<void> {
  await api.patch(`/users/${userId}/password`, { password });
}
